import React from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLeaf } from '@fortawesome/free-solid-svg-icons'

import logo from "../../assets/logo.svg";

import './styles.scss';

const navLinks = [
  // {
  //   link: '/dashboard',
  //   name: 'Dashboard',
  //   isActive: false,
  //   icon: faColumns
  // },
  {
    link: '/plants',
    name: 'Plants',
    isActive: false,
    icon: faLeaf
  }
];

const NavDesktop = () => {
  const currentPath = window.location.pathname;
  const linkList = navLinks.map((link) => {
    if (link.link === currentPath) {
      link.isActive = true;
      return link;
    }

    link.isActive = false;
    return link;
  });

  return (
    <div className="nav-container nav-desktop">
      <div className="inner-overlay" />
      <div className="inner-container">
        <div className="brand">
          <img
            className="app-logo"
            src={logo}
            alt="Home Plant Tracker logo"
          />
          <h5 className="title">Home Plant Tracker</h5>
        </div>
        <div className="nav-desktop-menu__container">
          <ul className="nav-desktop-menu__list">
            {linkList.map((link) => (
              <li className="nav-desktop-menu__list-item" key={link.name}>
                <Link to={link.link}>
                  <Button
                    className={link.isActive ? "nav-btn is-active" : 'nav-btn'}
                    color="primary"
                    outline={!link.isActive}
                  >
                    <FontAwesomeIcon
                      icon={link.icon}
                      size="sm"
                    />
                    {link.name}
                  </Button>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default NavDesktop;
